
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import {
	Col,
	Container,
	Nav,
	Navbar,
	NavbarBrand,
	NavItem,
	NavLink,
	Row,
	UncontrolledCollapse,
	UncontrolledTooltip,
} from "reactstrap";

class AdminNavbar extends React.Component {
	render() {
		return (
			<>
				<Navbar
					className="navbar-horizontal navbar-main navbar-dark navbar-transparent"
					expand="lg"
					id="navbar-main"
				>
					<Container>
						<NavbarBrand to="/" tag={Link}>
							<img alt="..." src={require("assets/img/brand/xareLogo_transparent.png")} />
						</NavbarBrand>
						<button
							aria-controls="navbar-collapse"
							aria-expanded={false}
							aria-label="Toggle navigation"
							className="navbar-toggler"
							data-target="#navbar-collapse"
							data-toggle="collapse"
							id="navbar-collapse"
							type="button"
						>
							<span className="navbar-toggler-icon" />
						</button>
						<UncontrolledCollapse
							className="navbar-custom-collapse"
							navbar
							toggler="#navbar-collapse"
						>
							<div className="navbar-collapse-header">
								<Row>
									<Col className="collapse-brand" xs="6">
										<Link to="/admin/dashboard">
											<img alt="..." src={require("assets/img/brand/blue.png")} />
										</Link>
									</Col>
									<Col className="collapse-close" xs="6">
										<button
											aria-controls="navbar-collapse"
											aria-expanded={false}
											aria-label="Toggle navigation"
											className="navbar-toggler"
											data-target="#navbar-collapse"
											data-toggle="collapse"
											id="navbar-collapse"
											type="button"
										>
											<span />
											<span />
										</button>
									</Col>
								</Row>
							</div>
							<hr className="d-lg-none" />
							<Nav className="align-items-lg-center ml-lg-auto" navbar>
								<NavItem>
									<NavLink
										className="nav-link-icon"
										href="https://www.facebook.com/creativetim?ref=creative-tim"
										id="tooltip601201423"
										target="_blank"
									>
										<i className="fab fa-facebook-square" />
										<span className="nav-link-inner--text d-lg-none">Facebook</span>
									</NavLink>
									<UncontrolledTooltip delay={0} target="tooltip601201423">
										Like us on Facebook
									</UncontrolledTooltip>
								</NavItem>
								<NavItem>
									<NavLink
										className="nav-link-icon"
										href="https://www.instagram.com/creativetimofficial?ref=creative-tim"
										id="tooltip871243015"
										target="_blank"
									>
										<i className="fab fa-instagram" />
										<span className="nav-link-inner--text d-lg-none">Instagram</span>
									</NavLink>
									<UncontrolledTooltip delay={0} target="tooltip871243015">
										Follow us on Instagram
									</UncontrolledTooltip>
								</NavItem>
								<NavItem>
									<NavLink
										className="nav-link-icon"
										href="https://twitter.com/creativetim?ref=creative-tim"
										id="tooltip366258619"
										target="_blank"
									>
										<i className="fab fa-twitter-square" />
										<span className="nav-link-inner--text d-lg-none">Twitter</span>
									</NavLink>
									<UncontrolledTooltip delay={0} target="tooltip366258619">
										Follow us on Twitter
									</UncontrolledTooltip>
								</NavItem>
							</Nav>
						</UncontrolledCollapse>
					</Container>
				</Navbar>
			</>
		);
	}
}

export default AdminNavbar;
